export default {
  strict: true,
  namespaced: true,
  state: {
    users: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'created',
      orderAsc: 1,
      loading: false,
      search: ''
    }
  },
  mutations: {
    resetUsers (state) { state.users.list = [] },
    addUsers (state, value) { state.users.list = value },
    setUserMaxList (state, value) { state.users.maxList = value },
    setUserCurrentPage (state, value) { state.users.currentPage = value },
    setUserPerPage (state, value) { state.users.perPage = value },
    setUserOrder (state, value) { state.users.order = value },
    setUserOrderAsc (state, value) { state.users.orderAsc = value },
    setUserLoading (state, value) { state.users.loading = value },
    setUserSearch (state, value) { state.users.search = value },
    updateUserStatus (state, data) {
      let index = state.users.list.findIndex(x => x.id === data.id)
      if (index !== -1) {
        state.users.list[index].active = data.active
      }
    }
  },
  sharedMutations: []
}
  


// WEBPACK FOOTER //
// ./src/store/corporate/list.js